<blockable-div #block>
  <app-progress-spinner [enabled]="!shiftTurnover" />
  <p-blockUI [blocked]="saving === true || loading === true" [target]="block" />
  @if (form) {
    <form [formGroup]="form" id="shiftturnover-create-form">
      <div class="xtra-small-top-padding" id="contact-action-buttons-select">
        <div class="no-padding-top-bottom" id="contact-form-controls-buttons">
          @if (shiftTurnover?.id && shouldShowEditSaveButtons()) {
            <div class="actions-dropdown">
              <span class="label"
                >{{ 'COMMON.LABEL.ACTIONS' | translate }}:</span
              >
              <span class="no-padding-top-bottom">
                <p-select
                  [options]="actions"
                  (onChange)="actionEvent($event, dd)"
                  [(ngModel)]="selectedAction"
                  [ngModelOptions]="{ standalone: true }"
                  styleclass="action-drop-down"
                  scrollHeight="calc(100vh-35vh)"
                  #dd
                />
              </span>
            </div>
          }
          @if (!isEditting && shouldShowEditSaveButtons()) {
            <div class="contact-button">
              <button
                pButton
                label="{{ 'COMMON.LABEL.BUTTONS.EDIT' | translate }}"
                icon="fa fa-fw fa-edit"
                (click)="setEditting()"
              ></button>
            </div>
          }
          @if (isEditting && shouldShowEditSaveButtons()) {
            <div class="contact-button">
              <button
                pButton
                label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
                icon="fa fa-fw fa-save"
                [disabled]="!this.form.valid || this.saving"
                (click)="saveShiftTurnover()"
              ></button>
            </div>
          }
          <div class="contact-button">
            <button
              pButton
              class="refresh-button"
              icon="fa fa-fw fa-refresh"
              (click)="refresh()"
            ></button>
          </div>
          @if (saving) {
            <div>
              <app-progress-spinner [enabled]="saving" />
            </div>
          }
        </div>
        <div class="row">
          <div class="no-padding-top-bottom row-item">
            <span class="label"
              >{{ 'CRM.LABEL.SHIFT_CHANGE' | translate }}:</span
            >
            <span class="row-input">
              <p-select
                [options]="shiftTypes"
                formControlName="shiftType"
                scrollHeight="calc(100vh-35vh)"
              />
            </span>
          </div>
          <div class="no-padding-top-bottom row-item">
            <span class="label"
              >{{ 'CRM.LABEL.CREATED_DATE' | translate }}:</span
            >
            <span class="row-input">
              <p-datepicker
                formControlName="createdDt"
                [showTime]="true"
                [showSeconds]="true"
                hourFormat="12"
              />
            </span>
          </div>
          <div class="row-item">
            @if (shiftTurnover?.departingCompletedDate) {
              <span class="row-label label"
                >{{ 'CRM.LABEL.DEPARTING_COMPLETED_DATE' | translate }}:</span
              >
              <span class="row-input">
                <p-datepicker
                  formControlName="departingCompleted"
                  [showTime]="true"
                  [showSeconds]="true"
                  hourFormat="12"
                />
              </span>
            }
          </div>
        </div>
        <div class="row">
          <div
            class="no-padding-top-bottom row-item"
            style="display: flex; align-items: center; height: 40px"
          >
            <span class="label"
              >{{ 'CRM.LABEL.TURNOVER_DATE' | translate }}:</span
            >
            <span class="row-input">
              <p-datepicker formControlName="shiftDate" />
            </span>
          </div>
          <div
            class="no-padding-top-bottom row-item"
            style="display: flex; align-items: center; height: 40px"
          >
            <span class="label">{{ 'CRM.LABEL.STATUS' | translate }}:</span>
            <span class="row-input">
              <input pInputText formControlName="status" />
            </span>
          </div>
          <div class="row-item">
            @if (shiftTurnover?.incomingCompletedDate) {
              <span class="row-label label"
                >{{ 'CRM.LABEL.INCOMING_COMPLETED_DATE' | translate }}:</span
              >
              <span class="row-input">
                <p-datepicker
                  formControlName="incomingCompleted"
                  [showTime]="true"
                  [showSeconds]="true"
                  hourFormat="12"
                />
              </span>
            }
          </div>
        </div>
        <div class="row">
          <div
            class="no-padding-top-bottom row-item"
            style="display: flex; align-items: center; height: 40px"
          >
            <span class="label"
              >{{ 'CRM.LABEL.DEPARTING_ANALYST' | translate }}:</span
            >
            <span class="row-input">
              <p-autoComplete
                [suggestions]="filteredContacts"
                formControlName="departingAnalyst"
                [dropdown]="true"
                optionLabel="fullName"
                (completeMethod)="contactSearch($event)"
                appendTo="body"
                [forceSelection]="true"
              />
            </span>
          </div>
          <div
            class="no-padding-top-bottom row-item"
            style="display: flex; align-items: center; height: 40px"
          >
            <span class="label"
              >{{ 'CRM.LABEL.INCOMING_ANALYST' | translate }}:</span
            >
            <span class="row-input">
              <p-autoComplete
                [suggestions]="filteredContacts"
                formControlName="incomingAnalyst"
                [dropdown]="true"
                optionLabel="fullName"
                (completeMethod)="contactSearch($event)"
                appendTo="body"
                [forceSelection]="true"
              />
            </span>
          </div>
          <div class="row-item"></div>
        </div>
      </div>
      <div class="break"></div>
      <div class="no-padding">
        @if (shiftTurnover?.ShiftDetails?.length ?? 0 > 0) {
          <header>{{ 'CRM.LABEL.DEPARTING_ANALYST' | translate }}</header>
          <section class="departing">
            <div class="no-padding-top-bottom departing-incoming-form">
              @for (
                item of getChildControls('items');
                track item;
                let j = $index
              ) {
                <div
                  class="no-padding-top-bottom form-row"
                  formArrayName="items"
                >
                  <div formGroupName="{{ j }}" class="form-row">
                    <div
                      class="no-padding-top-bottom form-area"
                      style="font-weight: 700"
                    >
                      {{ item.get('name')?.value }}:
                    </div>
                    <div class="form-area-comments">
                      <div>
                        <p-toggleButton
                          formControlName="departingTurnoverFlag"
                          onLabel="YES"
                          offLabel="NO"
                        />
                      </div>
                      <div class="input-field">
                        <textarea
                          pTextarea
                          autoResize="autoResize"
                          formControlName="departingComments"
                          [rows]="2"
                          [cols]="textAreaSize"
                        ></textarea>
                        <app-inline-validation
                          field="departingComments"
                          [control]="getItemFormChild(j, 'departingComments')"
                          [validationMessages]="validationMessages"
                          [validationParams]="validationParams"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div class="form-row">
                <div
                  class="no-padding-top-bottom form-area"
                  style="font-weight: 700"
                  [translate]="'CRM.LABEL.ADDITIONAL_COMMENTS'"
                ></div>
                <div class="input-field form-area-comments">
                  <textarea
                    pTextarea
                    formControlName="incomingAdditionalComments"
                    autoResize="autoResize"
                    [rows]="2"
                    [cols]="textAreaSize"
                  ></textarea>
                  <app-inline-validation
                    field="incomingAdditionalComments"
                    [control]="getBaseFormChild('incomingAdditionalComments')"
                    [validationMessages]="validationMessages"
                    [validationParams]="validationParams"
                  />
                </div>
              </div>
            </div>
            @if (canViewDeparting) {
              <div class="departing-questions">
                <div class="question-group">
                  <span
                    class="question-label"
                    [translate]="'CRM.LABEL.FIT_TO_DRIVE'"
                  >
                  </span>
                  <span class="no-padding-top-bottom">
                    <p-toggleButton
                      formControlName="departingFitFlag"
                      onLabel="YES"
                      offLabel="NO"
                    />
                  </span>
                </div>
                <div class="question-group-large">
                  <span
                    class="question-label"
                    [translate]="'CRM.LABEL.FATIGUE_MITIGATIONS'"
                  >
                  </span>
                  <div class="buttons">
                    @for (
                      item of getChildControls('mitigations');
                      track item;
                      let j = $index
                    ) {
                      <span class="button" formArrayName="mitigations">
                        <span formGroupName="{{ j }}" class="button">
                          <span class="button-label">{{
                            item.get('mitigationName')?.value
                          }}</span>
                          <span class="toggle">
                            <p-toggleButton
                              formControlName="turnoverFlag"
                              onLabel="YES"
                              offLabel="NO"
                            />
                          </span>
                        </span>
                      </span>
                    }
                  </div>
                </div>
              </div>
            }
          </section>
        }
      </div>
      @if (
        (shiftTurnover?.ShiftDetails?.length ?? 0) > 0 &&
        shiftTurnover?.status !== 'N' &&
        canViewIncoming
      ) {
        <p-panel header="{{ 'CRM.LABEL.INCOMING_ANALYST' | translate }}">
          <div class="questions">
            <div class="question-group">
              <span
                class="question-label"
                [translate]="'CRM.LABEL.MC_FIT_TO_WORK'"
              >
              </span>
              <span class="no-padding-top-bottom">
                <p-toggleButton
                  formControlName="incomingFitFlag"
                  onLabel="YES"
                  offLabel="NO"
                />
              </span>
            </div>
            <div class="question-group">
              <span
                class="question-label"
                [translate]="'CRM.LABEL.REVIEWED_ITEMS_WITH_DEPARTING'"
              >
              </span>
              <span class="no-padding-top-bottom">
                <p-toggleButton
                  onLabel="YES"
                  offLabel="NO"
                  formControlName="incomingReviewedAllSections"
                />
              </span>
            </div>
            <div class="input-field form-area question-group">
              <span
                class="question-label"
                [translate]="'CRM.LABEL.ADDITIONAL_COMMENTS'"
              ></span>
              <textarea
                pTextarea
                autoResize="autoResize"
                formControlName="departingAdditionalComments"
                [rows]="2"
                [cols]="textAreaSize"
              ></textarea>
              <app-inline-validation
                field="departingAdditionalComments"
                [control]="getBaseFormChild('departingAdditionalComments')"
                [validationMessages]="validationMessages"
                [validationParams]="validationParams"
              />
            </div>
          </div>
        </p-panel>
      }
    </form>
  }
</blockable-div>
